import { BookingState } from './AppointmentBookingPane.types';

export const createBookingState = (options?: Partial<BookingState>): BookingState => {
  return {
    companyId: null,
    windowResponses: {
      companyWindows: [],
      configuredCompanyWindows: [],
      appointmentWindows: [],
      appointments: [],
      companyWindowsIdMap: {},
      availableWindows: []
    },
    selectedDate: null,
    isSaving: false,
    filterContext: null,
    forceFilterRefresh: false,
    errorFetchingWindows: false,
    filteredWindows: [],
    validationErrors: undefined,
    ...options
  };
};
